import { useState, useEffect, useMemo } from 'react';
export default function useAsync(methodToInvoke, deps = []) {
    const [isResolved, setIsResolved] = useState(false);
    const [isRejected, setIsRejected] = useState(false);
    const [isFinished, setIsFinished] = useState(false);
    const [result, setResult] = useState();
    const dependencies = useMemo(() => {
        return [...deps, methodToInvoke];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    useEffect(() => {
        methodToInvoke()
            .then((resolution) => {
            setResult(resolution);
            setIsFinished(true);
            setIsResolved(true);
            setIsRejected(false);
        })
            .catch((reason) => {
            setResult(reason);
            setIsFinished(true);
            setIsResolved(false);
            setIsRejected(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
    return { isResolved, isRejected, isFinished, result };
}
//# sourceMappingURL=UseAsync.js.map